import React, { useState, useCallback, useMemo } from "react";
import QboxmailApi from "../../qboxmailApi";
import AsyncSelect from "react-select/async";
import { t } from "i18next";
import cx from "classnames";
import s from "./customerSelect.scss";
import debounce from "debounce-promise";

const CustomerSelect = ({
  initialValue,
  withDomainCounter = true,
  className,
  label,
  selectSizeSmall,
  errors,
  onChange,
}) => {
  const [selected, setSelected] = useState();

  const fetchCustomers = useCallback(
    async (query) => {
      try {
        const client = new QboxmailApi({ useCookie: true });
        const params = query ? { per: 500, query } : { query: initialValue };

        const data = await client.getCustomers(params);
        const options = data.resources.map((res) => ({
          value: res.code,
          label: `${res.fullname} - ${res.email_address}${withDomainCounter ? ` (${res.domains})` : ""}`,
          catch_all: res.catch_all,
          data: res,
        }));

        if (!query && initialValue) {
          const found = options.find((o) => o.value === initialValue);
          if (found) {
            setSelected(found);
            if (onChange) onChange(found);
          }
        }

        return options;
      } catch (error) {
        return [];
      }
    },
    [initialValue, withDomainCounter, onChange]
  );

  const loadOptions = useMemo(() => debounce(fetchCustomers, 500, { leading: true }), [fetchCustomers]);

  const handleChange = (option) => {
    setSelected(option);
    if (onChange) onChange(option);
  };

  const styles = useMemo(
    () => ({
      dropdownIndicator: () => ({ display: "none" }),
      indicatorSeparator: () => ({ display: "none" }),
    }),
    []
  );

  return (
    <div className={cx(className, s.customerSelect, { [s.withErrors]: errors })}>
      {label && (
        <div className={s.wrapLabel}>
          <label className={s.label}>{label}</label>
        </div>
      )}
      <AsyncSelect
        styles={styles}
        className={cx("wrapSelect", {
          selectSizeSmall: selectSizeSmall,
          selectWithError: !!errors,
        })}
        classNamePrefix="select"
        defaultOptions={!!initialValue}
        loadOptions={loadOptions}
        value={selected}
        onChange={handleChange}
        isClearable
        placeholder={t("input.placeholder.customerSelect")}
        noOptionsMessage={() => t("input.placeholder.noFoundCustomers")}
      />
      {errors && <div className={s.errorMsg}>{errors}</div>}
    </div>
  );
};

export default CustomerSelect;
